import styled from 'styled-components'
import { colors, fonts } from '@/styled/vars'
import { RootButton } from '@root/RootButton'
import { ReactComponent as Close } from '@/assets/svg/close.svg'

export const CardModalWrapper = styled.div`
  display: flex;
  width: 100%;
  max-width: 480px;
  flex-direction: column;
  gap: 16px;
  padding-top: 10px;
  border-radius: 32px;
  background: linear-gradient(180deg, #1a0534 0%, #0c011a 100%);
`

export const ImgBox = styled.div`
  position: relative;
  overflow: hidden;
  border-radius: 16px 16px 0 0;

  & > img {
    width: 100%;
    object-fit: contain;
    max-height: clamp(22.5rem, 7.955rem + 72.73vw, 30rem);
    border-radius: 32px 32px 0 0;
  }
`

export const CloseModal = styled.button`
  position: absolute;
  top: 10px;
  right: 10px;
  width: 24px;
`

export const CloseIcon = styled(Close)`
  width: 100%;
`

export const Body = styled.div`
  padding: 16px;
  text-align: center;
`

export const Title = styled.h2`
  margin-bottom: 12px;
  color: ${colors.white};
  font-size: 20px;
  font-weight: 600;
  line-height: 1.5;
`

export const Description = styled.p`
  margin-bottom: 16px;
  color: ${colors.white};
  font-family: ${fonts.exo};
  font-size: 14px;
  font-weight: 400;
  line-height: 1.5;
`

export const Footer = styled.form`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  padding: 0 16px 16px;
  column-gap: 16px;
  gap: clamp(0.75rem, -0.826rem + 7.88vw, 1.563rem);
`

export const Price = styled.span`
  color: ${colors.white};
  font-size: clamp(1.125rem, 0.883rem + 1.21vw, 1.25rem);
  font-weight: 700;
  line-height: 1.2;
`

export const Sizes = styled.div`
  position: relative;
  display: flex;
  height: 40px;
  border-radius: 20px;
  background-color: ${colors.lightNeon};
`

export const Selected = styled.div<{ position: number }>`
  position: absolute;
  top: 0;
  bottom: 0;
  left: ${({ position }) => position}px;
  width: calc(20%);
  padding: 2px;
  transition: left 200ms ease-out 0s, width;

  &::before {
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 16px;
    background-color: ${colors.indigo};
    box-shadow: 0 0 8px rgba(0, 0, 0, 0.25);
    content: ' ';
  }
`

export const SizeInput = styled.input`
  position: absolute;
  display: none;

  &:checked + label {
    color: ${colors.white};
    font-weight: 500;
  }
`

export const SizeLabel = styled.label`
  position: relative;
  display: block;
  flex: 1 1 0;
  border-radius: 9999px;
  color: ${colors.white};
  cursor: pointer;
  font-size: 12px;
  font-weight: 400;
  line-height: 40px;
  text-align: center;
  text-transform: uppercase;
  transition: color 150ms ease 0s, font-weight 0.3s;
  user-select: none;

  &:hover {
    color: ${colors.white};
  }
`

export const Button = styled(RootButton)`
  flex: 1 1 auto;
  color: #fff;
`
